import axios from "axios";
import VueAxios from "vue-axios";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
Vue.use(VueAxios, axios);
Vue.use(Vuex);

import { EncryptStorage } from "encrypt-storage";
export const encryptStorage = new EncryptStorage("secret-key-value", {
  prefix: "@res",
  encAlgorithm: "Rabbit",
});
export default new Vuex.Store({
  state: {
    connection_snack: false,
    drawer: true,
    mini: false,
    def_path: "https://ba.biglike.app",
    //def_path: "http://127.0.0.1:8000",
    token: encryptStorage.getItem("token_vinish") || null,
    vinish: encryptStorage.getItem("vinish") || null,
    break_point: 0,
    langs: {
      done: false,
      data: [],
    },
    countries: {
      done: false,
      data: [],
    },
    workers: {
      done: false,
      data: [],
    },
    services: {
      done: false,
      data: [],
    },
  },
  getters: {
    loggedin(state) {
      return state.token != null;
    },
    items: (stat) => (items) => {
      return stat[items];
    },
    default_lang(state) {
      if (state.langs.done) {
        return state.langs.data.find((l) => l.is_default);
      }
    },
    casher: (state) => (items) => {
      return state.casher[items];
    },
    has_casher(state) {
      return !!state.casher.products.length;
    },
    services(state) {
      return state.services.data;
    },
    workers(state) {
      return state.workers.data;
    },
    user(state) {
      return state.vinish;
    },
    role(state) {
      return state.vinish ? state.vinish.role : null;
    },
  },
  mutations: {
    login(state, token) {
      state.token = token;
    },
    logout(state) {
      state.token = null;
      encryptStorage.removeItem("token_vinish");
      encryptStorage.removeItem("vinish");
      state.langs.done = false;
    },
    user(state, user) {
      state.vinish = user;
    },
    store_items(state, items) {
      state[items.items].data = items.data;
      if (items.data.length) {
        state[items.items].done = true;
      }
    },
    update_props(state, obj) {
      state[obj.items].data[obj.index][obj.prop] = obj.val;
    },
  },
  actions: {
    login(context, cred) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("phone", cred.phone);
        formData.append("password", cred.password);
        var config = {
          method: "post",
          url: "https://ba.biglike.app/api/login",
          // url: "http://127.0.0.1:8000/api/login",
          headers: {
            Accept: "application/json",
          },
          data: formData,
        };
        axios(config)
          .then((res) => {
            const token = res.data.data.token;
            encryptStorage.setItem("token_vinish", token);
            encryptStorage.setItem("vinish", res.data.data);
            context.commit("login", token);
            context.commit("user", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // public request this function handel any requset type like post & get Etc ...
    public__request(context, cred) {
      return new Promise((resolve, reject) => {
        let config = {
          method: cred.config.method,
          url: cred.config.url,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${context.state.token}`,
          },
          data: cred.data || [],
        };
        axios(config)
          .then((res) => {
            resolve(res);
            context.state.connection_snack = false;
            if (cred.get) {
              context.commit("public__request", {
                data: res.data,
                name: cred.get,
              });
            }
          })
          .catch((err) => {
            if (!err.response) {
              context.state.connection_snack = true;
            } else {
              reject(err);
            }
            if (err.response.status == 401) {
              context.commit("logout");
              router.push("/");
            }
          });
      });
    },
    get_requirements(context, cred) {
      context
        .dispatch("public__request", {
          config: {
            url: "requirements",
            method: "get",
          },
        })
        .then((res) => {
          context.commit("store_items", {
            items: "langs",
            data: res.data.data.langs,
          });
          context.commit("store_items", {
            items: "countries",
            data: res.data.data.countries,
          });
          context.commit("store_items", {
            items: "workers",
            data: res.data.data.workers,
          });
          context.commit("store_items", {
            items: "services",
            data: res.data.data.services,
          });
        });
    },
  },
  modules: {},
});
